module.exports = __webpack_public_path__ + "img/RPA-1.b471a21f.png";